
import React, { useState } from 'react';
import MeatIcon from './icons/MeatIcon';

interface LogoProps {
    className?: string;
}

const Logo: React.FC<LogoProps> = ({ className }) => {
    // We add a timestamp to force the browser to retry loading the image 
    // instead of using a cached 404 response if the file was just uploaded.
    const [timestamp] = useState(Date.now());
    const [imgSrc, setImgSrc] = useState(`/logo.png?v=${timestamp}`);
    const [error, setError] = useState(false);

    const handleError = () => {
        // If the standard /logo.png path fails, try /public/logo.png
        // This handles differences between build environments (Vite/CRA) and raw file servers
        if (imgSrc.startsWith('/logo.png')) {
            setImgSrc(`/public/logo.png?v=${timestamp}`);
        } else {
            // Both paths failed
            setError(true);
        }
    };

    if (error) {
        return (
            <div className={`relative flex items-center justify-center ${className}`} title="Image load failed. Ensure logo.png is in the public folder.">
                <MeatIcon className="w-full h-full text-red-600" />
            </div>
        );
    }

    return (
        <img 
            src={imgSrc} 
            alt="mealPai Logo" 
            className={`object-contain drop-shadow-sm ${className}`}
            // Inline style fallback to ensure the image never explodes in size 
            // even if Tailwind CSS fails to load (e.g. build error)
            style={{ maxWidth: '100%', maxHeight: '100%' }}
            onError={handleError}
        />
    );
};

export default Logo;